import { render } from "./parametersComponent.vue?vue&type=template&id=60d9f9d2&scoped=true"
import script from "./parametersComponent.vue?vue&type=script&lang=js"
export * from "./parametersComponent.vue?vue&type=script&lang=js"

import "./parametersComponent.vue?vue&type=style&index=0&id=60d9f9d2&lang=scss&scoped=true"
import "./parametersComponent.vue?vue&type=style&index=1&id=60d9f9d2&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d9f9d2"]])

export default __exports__